module.exports = __webpack_public_path__ + "img/可视门铃.9c0f67d2.jpg";